(() => {
 'use strict';
 // Convert only simple specification lists in the rendered description. Store data is untouched.
 const formatSpecs = () => document.querySelectorAll('[product-description-tab] h4').forEach(heading => {
  if (heading.textContent.trim() !== '商品規格') return;
  const list = heading.nextElementSibling;
  if (!list || list.tagName !== 'UL') return;
  const items = [...list.children];
  if (!items.length || items.some(item => item.children.length || !item.textContent.includes('：'))) return;
  const table = document.createElement('table'); table.className = 'qa-specs';
  const caption = table.createCaption(); caption.className = 'visually-hidden'; caption.textContent = '商品規格';
  const body = table.createTBody();
  items.forEach(item => {
   const text = item.textContent; const split = text.indexOf('：'); const row = body.insertRow();
   const label = document.createElement('th'); label.scope = 'row'; label.textContent = text.slice(0, split);
   row.append(label); row.insertCell().textContent = text.slice(split + 1);
  });
  list.replaceWith(table);
 });
 formatSpecs(); document.addEventListener('shopify:section:load', formatSpecs);
 const syncWishlist = () => document.querySelectorAll('[data-wishlist]').forEach(button => {
  button.setAttribute('aria-label', button.classList.contains('wishlist-added') ? '移除願望清單' : '加入願望清單');
 });
 syncWishlist();
 const wishlistRegion = document.querySelector('[data-wishlist-container]');
 if (wishlistRegion) new MutationObserver(syncWishlist).observe(wishlistRegion, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
 document.querySelectorAll('.productView [data-wishlist]').forEach(button => new MutationObserver(syncWishlist).observe(button, {attributes:true,attributeFilter:['class']}));
 document.addEventListener('click', event => { if (event.target.closest('[data-wishlist]')) setTimeout(syncWishlist, 0); });
 document.querySelectorAll('.search__input[type="search"]').forEach(input => {
  const field = input.closest('.field'); if (!field) return;
  const clear = document.createElement('button'); clear.type = 'button'; clear.className = 'qa-search-clear';
  clear.setAttribute('aria-label', '清除搜尋'); clear.textContent = '×';
  const sync = () => { clear.hidden = !input.value; };
  clear.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); input.value = ''; input.dispatchEvent(new Event('input', {bubbles:true})); input.focus(); sync(); });
  input.addEventListener('input', sync); field.append(clear); field.classList.add('qa-search-field'); sync();
 });
 const menu = document.querySelector('#navigation-mobile');
 if (menu) {
  const sync = () => { menu.inert = !document.body.classList.contains('menu_open'); };
  new MutationObserver(sync).observe(document.body, {attributes:true,attributeFilter:['class']}); sync();
 }
})();
